/** Shared department options for Petty Cash add/edit forms */
export const PETTY_CASH_DEPARTMENTS = [
  "Bar",
  "Kitchen",
  "Poker Room",
  "Common",
  "Brownsville",
];
